import { useAccount } from '@hcs/authn';

export const useOrgIsSelfServe = () => {
  const accountQuery = useAccount();
  const { data, isSuccess } = accountQuery;
  return {
    ...accountQuery,
    data: isSuccess ? data.organization.type === 'selfserve' : undefined,
  };
};
